
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from './copysource';
import { FormatReadSettings } from './format-read-settings/format-read-settings';
import { StoreReadSettings } from './store-read-settings/store-read-settings';

@Metamodel.model({
    abstract: true
})
export abstract class FormatTypeCopySource extends CopySource {
    public static readonly MODEL: IModel;

    // for dataset v2
    @Metamodel.attribute({
        display: stringResources.ModelName_StoreReadSettings,
        type: StoreReadSettings.MODEL
    })
    public storeSettings?: StoreReadSettings;

    // for dataset v2
    @Metamodel.attribute({
        display: stringResources.ModelName_FormatReadSettings,
        type: FormatReadSettings.MODEL
    })
    public formatSettings?: FormatReadSettings;
}
